// routes.js (CORRECTED AND SECURE VERSION)

import Dashboard from 'layouts/dashboard';
import Orgs from 'layouts/orgs';
import Products from 'layouts/products';
import Commit from 'layouts/commit';
import Deploy from 'layouts/deploy';
import ActivityHistory from 'layouts/activityHistory';
import Profile from 'layouts/profile';
import SignIn from 'layouts/authentication/sign-in';
import ArgonBox from 'components/ArgonBox';
import Configuration from 'layouts/configuration';
import Offering from 'layouts/offerings';
import Customization from 'layouts/customization';
import CustomObjects from 'layouts/custom-objects';
// --- DEFINE AUTHENTICATED ROUTES HERE ---
// This array contains ONLY the routes a logged-in user should see.
const authenticatedRoutes = [
  {
    type: 'route',
    name: 'Dashboard',
    key: 'dashboard',
    route: '/dashboard',
    icon: <ArgonBox component="i" color="primary" fontSize="14px" className="ni ni-tv-2" />,
    component: <Dashboard />,
  },
  {
    type: 'route',
    name: 'Salesforce Orgs',
    key: 'orgs',
    route: '/orgs',
    icon: <ArgonBox component="i" color="warning" fontSize="14px" className="ni ni-calendar-grid-58" />,
    component: <Orgs />,
  },
  {
    type: 'collapse',
    name: 'Catalogue',
    key: 'catalogue',
    icon: <ArgonBox component="i" color="info" fontSize="14px" className="ni ni-app" />,
    collapse: [
      {
        type: 'route',
        name: 'Products',
        key: 'products',
        icon: <ArgonBox component="i" color="info" fontSize="14px" className="ni ni-bullet-list-67" />,
        route: '/catalogue/products',
        component: <Products />,
      },
      {
        type: 'route',
        name: 'Configuration',
        key: 'configuration',
        icon: <ArgonBox component="i" color="info" fontSize="14px" className="ni ni-books" />,
        route: '/catalogue/configuration',
        component: <Configuration />,
      },
      {
        type: 'route',
        name: 'Offerings',
        key: 'offerings',
        icon: <ArgonBox component="i" color="info" fontSize="14px" className="ni ni-folder-17" />,
        route: '/catalogue/offerings',
        component: <Offering />,
      },
      {
        type: 'route',
        name: 'Customisation',
        key: 'customisation',
        icon: <ArgonBox component="i" color="info" fontSize="14px" className="ni ni-ui-04" />,
        route: '/catalogue/customisation',
        component: <Customization />,
      },
      {
        type: 'route',
        name: 'Custom Objects',
        key: 'custom-objects',
        icon: <ArgonBox component="i" color="info" fontSize="14px" className="ni ni-collection" />,
        route: '/catalogue/custom-objects',
        component: <CustomObjects />,
      },
    ],
  },
  {
    type: 'route',
    name: 'Change Management',
    key: 'commit',
    route: '/commit',
    icon: <ArgonBox component="i" color="info" fontSize="14px" className="ni ni-cloud-download-95" />,
    component: <Commit />,
  },
  {
    type: 'route',
    name: 'Deployment Management',
    key: 'deploy',
    route: '/deploy',
    icon: <ArgonBox component="i" color="info" fontSize="14px" className="ni ni-cloud-upload-96" />,
    component: <Deploy />,
  },
  {
    type: 'route',
    name: 'Activity History',
    key: 'activityHistory',
    route: '/activityHistory',
    icon: <ArgonBox component="i" color="info" fontSize="14px" className="ni ni-time-alarm" />,
    component: <ActivityHistory />,
  },
  { type: 'divider', key: 'profileDivider' },
  {
    type: 'route',
    name: 'Profile',
    key: 'profile',
    route: '/profile',
    icon: <ArgonBox component="i" color="dark" fontSize="14px" className="ni ni-single-02" />,
    component: <Profile />,
  },
];

// --- DEFINE PUBLIC ROUTES HERE ---
// This array contains ONLY the routes an unauthenticated user should see.
const publicRoutes = [
  {
    type: 'route',
    name: 'Sign In',
    key: 'signin',
    route: '/authentication/sign-in',
    component: <SignIn />,
  },
  // You could add a sign-up route here as well
  // {
  //   type: 'route',
  //   name: 'Sign Up',
  //   key: 'signup',
  //   route: '/authentication/sign-up',
  //   component: <SignUp />,
  // },
];

/**
 * This function is now simple and foolproof. It returns one array or the other.
 * There is no chance of a protected route leaking into the public configuration.
 * @param {boolean} isAuthenticated
 * @returns {Array} The routes array for the current auth state.
 */
export default function generateRoutes(isAuthenticated) {
  return isAuthenticated ? authenticatedRoutes : publicRoutes;
}
